import styles from '../DraftEditor.less';

const getIcon = (feature) => `/assets/icons/wysiwyg/${feature}.svg`;

export const customizeFeature = (feature) => ({
  icon: getIcon(feature),
  className: styles.editorToolbarIcon,
});
